// this component is for SMARTLGU

/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { abbreviateThousands, numberWithCommas } from 'helper';
import withDashboard from '../../common/hoc/withDashboard';
import * as c from '../constants';
import * as actions from '../actions';

const CollectionsGraphV2 = ({
  getCollections,
  collections, // per month
  createDynamicAreaChartVersion2,
  isLoading,
  getYearList,
  yearList,
  className,
}) => {
  const initForm = {
    year: moment(new Date()).format('YYYY'),
  };

  var index = yearList.map(function (x) { return +x.year; }).indexOf(+initForm.year);

  const [filterData, setFilterData] = useState(initForm);
  const [isButtonClick, setIsButtonClicked] = useState(false);


  useEffect(() => {
    getYearList()
    getCollections({ year: filterData.year })
  }, []);

  const GroupCollectionByYear = _.groupBy(collections, 'year')

  let collectionPerYear = []

  collectionPerYear = _.map(GroupCollectionByYear, (value, year) => {
    return {
      year,
      sum: _.reduce(value, (total, item) => total + item.collection, 0)
    }
  })

  const handleOnFilterYear = (value) => (e) => {
    e.preventDefault()
    setFilterData({
      ...filterData,
      year: value,
    })
    setIsButtonClicked(true);
    getCollections({ year: value })
  }

  const formatNumberWithCommas = value => {
    return value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const displayAreaChart = createDynamicAreaChartVersion2(
    collections,
    [{ key: filterData.year, color: '#5272AA' }],
    {
      xAxisProps: {
        fontSize: '10px',
        // angle: -35,
        scale: 'point',
      },
      yAxisProps: {
        // angle: -55,
      },
      composeOption: {
        bottom: 20,
      },
    },
    isLoading
  )

  return (
    <div className={`collections container-fluid item-box-shadow ${className}`}>
      <div className="w-100">
        <h4 className="cms-text-primary font-weight-bold pl-2 mb-4">
          Collections
        </h4>
      </div>
      <div className="collections-body">
        <div className="year-container">
          <ul>
            {isButtonClick === false && (
              yearList.map((item, i) => (
                <li key={item.year}>
                  <button
                    className={`btn btn-link btn-col-year rounded ${index === i ? 'btn-active' : ''}`}
                    type="button"
                    onClick={handleOnFilterYear(item.year)}
                  >
                    {item.year}
                  </button>
                </li>
              ))
            )}
            {isButtonClick === true && (
              yearList.map(item => (
                <li key={item.year}>
                  <button
                    className={`btn btn-link btn-col-year rounded ${item.year === filterData.year ? 'btn-active' : ''}`}
                    type="button"
                    onClick={handleOnFilterYear(item.year)}
                  >
                    {item.year}
                  </button>
                </li>
              ))
            )}
          </ul>
        </div>
        <div className="area-body">
          <div className="year-headers">
            {/* <div className="yh-numbers"> */}
            <ul
              className="d-flex justify-content-around flex-row p-0"
              style={{ listStyleType: 'none', width: '100%', fontSize: '12px' }}
            >
              {
                collectionPerYear.map(collection => {
                  return (
                    <li key={collection.year}>
                      <div className="d-flex justify-content-center flex-column mx-2">
                        <div
                          style={{ textAlign: 'center' }}
                          className="yh-year w-100 font-weight-bold mb-0"
                        >
                          {collection.year}
                        </div>
                        <div className="d-flex justify-content-around align-items-center">
                          <span
                            style={{ fontSize: '16px' }}
                            className="yh-total per-year-total"
                          >
                            {formatNumberWithCommas(collection.sum)}
                          </span>
                          <span className="yh-meter pos per-year-percentage">
                            100% <i className="fas fa-angle-up pl-2" />
                          </span>
                        </div>
                      </div>
                    </li>
                  )
                })
              }
            </ul>
            {/* </div> */}
          </div>
          {/* LEGENDS */}
          <div className="my-3 legends" style={{ fontSize: '13px' }}>
            <label>Legend:</label>
            <div className="legend inc"> 
              Increase <i className="fas fa-angle-up pl-2" />
            </div>
            <div className="legend decr">
              Decrease <i className="fas fa-angle-down pl-2" />
            </div>
            <div className="legend star">
              Current <i className="fas fa-star pl-2" />
            </div>
          </div>
          {/* graph */}
          {displayAreaChart}
        </div>
      </div>
    </div>
  );
};

CollectionsGraphV2.defaultProps = {
  collections: [],
  className: '',
};

CollectionsGraphV2.propTypes = {
  createDynamicAreaChart: PropTypes.instanceOf(Function).isRequired,
  createDynamicAreaChartVersion2: PropTypes.instanceOf(Function).isRequired,
  getCollections: PropTypes.instanceOf(Function).isRequired,
  collections: PropTypes.instanceOf(Array),
  isLoading: PropTypes.bool.isRequired,
  getYearList: PropTypes.instanceOf(Function).isRequired,
  yearList: PropTypes.instanceOf(Array).isRequired,
  className: PropTypes.string,
};

const mapStateToProps = ({ api }) => ({
  collections: formatCollections(_.get(api, `${c.GET_COLLECTION}.res`)),
  yearList: _.get(api, `${c.GET_YEAR_LIST}.list`) || [],
  isLoading: api.loading.indexOf(c.GET_COLLECTION) > -1,
});

const enhance = _.flowRight([
  withDashboard,
  withRouter,
  connect(mapStateToProps, actions),
]);

const formatCollections = (data) => {
  const newArr = [];
  if (_.get(data, 'data')) {
    _.get(data, 'data').map((val, idx) => {
      data[idx] = {
        ...val,
        name: moment.months(parseInt(val.name) - 1),
      };
      newArr.push(data[idx]);
    });
    return newArr;
  }
  return data;
};

export default enhance(CollectionsGraphV2);
